var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "flat": "",
      "tile": "",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.page.src
    }
  }), _c('v-overlay', _vm._b({
    attrs: {
      "absolute": "",
      "value": true
    }
  }, 'v-overlay', {
    color: _vm.active ? 'white' : 'black',
    class: {
      'primary--text': _vm.active,
      'font-weight-black': true
    },
    style: {
      border: _vm.active ? '5px solid var(--v-primary-base)' : undefined
    }
  }, false), [_vm._v(" " + _vm._s(_vm.index + 1) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }